import { useState, useEffect, useMemo } from "react";
import { Offer } from "@/types/airtable";
import { API_CONFIG } from "@/config/api";

interface ApiResponse {
  offers: Offer[];
  cached: boolean;
  timestamp: string;
}

export function useOffers() {
  const [offers, setOffers] = useState<Offer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOffers = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.OFFERS}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`API error! status: ${response.status}`);
      }

      const data: ApiResponse = await response.json();
      setOffers(data.offers);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch offers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const memoizedOffers = useMemo(() => offers, [offers]);

  return {
    offers: memoizedOffers,
    loading,
    error,
    refetch: fetchOffers,
  };
}